import axios from "axios";
import { nextTick } from 'vue';


// Create an Axios instance with default settings
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const apiClient = axios.create({

   baseURL: "https://mh13.in/app/index.php/api/", // Replace with your API URL
// baseURL: "https://mh13.in/app//", 
  timeout: 10000, // Optional: Set a timeout

   headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  }

});



// Add a request interceptor to include the token

apiClient.interceptors.request.use(

  (config) => {
  $(".loader-wrapper").show(); 
    const token = localStorage.getItem("token");

    if (token) {

      config.headers.Authorization = `${token}`;

    }

    return config;

  },

 (error) => {
     $(".loader-wrapper").hide(); 
     Promise.reject(error);
     
 }

);



// Handle response errors globally (optional)

apiClient.interceptors.response.use(
  async (response) => {
    await nextTick(); // ✅ wait for Vue to re-render
    $(".loader-wrapper").hide();
    return response;
  },
  async (error) => {
    await nextTick();
    $(".loader-wrapper").hide();
     if (error.response?.status === 401) {
          localStorage.removeItem("token");
     }
    return Promise.reject(error);
  }
);


// apiClient.interceptors.response.use(

//   async (response) => {
//     await nextTick();
//     $(".loader-wrapper").hide();  

//     return response;

//   },

//   async (error) => {
//       await nextTick();
//     $(".loader-wrapper").hide(); 
//     if (error.response?.status === 401) {

//       // Token expired or unauthorized

//       localStorage.removeItem("token");

//       // window.location.href = "/login";  

//     }

//     return Promise.reject(error);

//   }

// );



export default apiClient;

